<template>
  <NuxtLayout data-theme="Soleando">
    <NuxtPage />
  </NuxtLayout>
  <GlobalToast />
  <div id="teleports"></div>
</template>

<script setup></script>

<style scoped></style>
